





















export default {
  name: "max-icon",
  props: {
    title: {
      type: String,
      default: "max icon"
    },
    decorative: {
      type: Boolean,
      default: false
    }
  }
}
